import { render, staticRenderFns } from "./NotificationDelaysTable.vue?vue&type=template&id=ecbb45d8&scoped=true"
import script from "./NotificationDelaysTable.vue?vue&type=script&lang=js"
export * from "./NotificationDelaysTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationDelaysTable.vue?vue&type=style&index=0&id=ecbb45d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbb45d8",
  null
  
)

export default component.exports